export default "__VITE_ASSET__2135fa0a__"